import { __assign, __extends, __spreadArray } from "tslib";
import React, { PureComponent } from "react";
import { render } from "react-dom";
import { makeStyles, createStyles, Snackbar, ThemeProvider } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import globalTheme from "../theme";
var useStyles = makeStyles(function (theme) {
  return createStyles({
    alert: {
      marginBottom: 10,
      paddingTop: 3,
      paddingBottom: 3
    }
  });
});

function Alert(props) {
  var classes = useStyles();
  return React.createElement(MuiAlert, __assign({
    elevation: 6,
    variant: "filled",
    className: classes.alert
  }, props));
}

var MessageComponent =
/** @class */
function (_super) {
  __extends(MessageComponent, _super);

  function MessageComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      open: false,
      msgs: []
    };
    return _this;
  }

  MessageComponent.prototype._removeMsg = function (id) {
    var msgs = this.state.msgs;
    var filtered = msgs.filter(function (v) {
      return v.id !== id;
    });
    this.setState({
      open: filtered.length > 0,
      msgs: filtered
    });
  };

  MessageComponent.prototype._addMsg = function (msg) {
    // this._init();
    var msgs = this.state.msgs;
    this.setState({
      open: true,
      msgs: __spreadArray(__spreadArray([], msgs, true), [msg], false)
    });

    var close = this._removeMsg.bind(this, msg.id);

    var hideTimeout = setTimeout(function () {
      close();
    }, msg.duration || 5000);
    return function closeManually() {
      clearTimeout(hideTimeout);
      close();
    };
  };

  MessageComponent.prototype.success = function (content, duration) {
    var id = "".concat(Math.random());
    var msg = {
      id: id,
      type: "success",
      content: content,
      duration: duration
    };
    return this._addMsg(msg);
  };

  MessageComponent.prototype.error = function (content, duration) {
    var id = "".concat(Math.random());
    var msg = {
      id: id,
      type: "error",
      content: content,
      duration: duration
    };
    return this._addMsg(msg);
  };

  MessageComponent.prototype.warning = function (content, duration) {
    var id = "".concat(Math.random());
    var msg = {
      id: id,
      type: "warning",
      content: content,
      duration: duration
    };
    return this._addMsg(msg);
  };

  MessageComponent.prototype.info = function (content, duration) {
    var id = "".concat(Math.random());
    var msg = {
      id: id,
      type: "info",
      content: content,
      duration: duration
    };
    return this._addMsg(msg);
  };

  MessageComponent.prototype.render = function () {
    var _a = this.state,
        open = _a.open,
        msgs = _a.msgs;
    return React.createElement(ThemeProvider, {
      theme: globalTheme
    }, React.createElement(Snackbar, {
      open: open
    }, React.createElement("div", null, msgs.map(function (msg) {
      return React.createElement(Alert, {
        key: msg.id,
        severity: msg.type
      }, msg.content);
    }))));
  };

  return MessageComponent;
}(PureComponent);

var messageInstance;

function init() {
  if (messageInstance) {
    return messageInstance;
  }

  var component = React.createElement(MessageComponent, null);
  var container = document.createElement("div");
  document.body.appendChild(container);
  var newMessageInstance = render(component, container);
  messageInstance = newMessageInstance;
  return messageInstance;
}

export default {
  success: function success(content, duration) {
    var message = init();
    return message.success(content, duration);
  },
  error: function error(content, duration) {
    var message = init();
    return message.error(content, duration);
  },
  warning: function warning(content, duration) {
    var message = init();
    return message.warning(content, duration);
  },
  info: function info(content, duration) {
    var message = init();
    return message.info(content, duration);
  }
};